<template>
  <b-form-file
    v-if="file"
    class="dynamic-fileupload"
    :id="file.id"
    :name="(isDocument && name != 'render_0') ? file.type : name"
    :required="(!entity || name == 'render') ? required : false"
    :multiple="file.multiple"
    :placeholder="documentName"
    drop-placeholder="Deja tu fichero aquí..."
    :accept="(documentName === 'pack_image' || documentName === 'pack_image_schema') ? 'image/*' : ''"
  ></b-form-file>
</template>

<script>
export default {
  name: 'DynamicformFileUpload',
  props: {
    file: {
      type: Object,
      default: null,
    },
    name: {
      type: String,
      default: '',
    },
    entity: {
      type: Object,
      required: false
    },
    placeDocument: {
      type: String,
      default: ''
    },
    isDocument: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    documentName() {
    console.log(this.$props);
      if (this.$props.name === 'export_files')
        return 'Selecciona archivo .zip';

      if (this.$props.name === 'pack_image')
        return 'Selecciona imagen del pack';

      if (this.$props.name === 'pack_image_schema')
        return 'Selecciona imagen croquis';

      if (this.$props.name === 'render' || this.$props.name === 'render_0')
        return 'Selecciona render';

      if(this.$props.name !== '')
        return this.$props.name;
        return this.$props.file.type;
    },
    placeHolder(){
      if(this.$props.placeDocument !== '')
        return this.$props.placeDocument;
      return "Selecciona un fichero";
    },
    required(){
    console.log(this.$props.file.required);
      if(this.$props.placeDocument !== '' || this.$props.file.required == true){
        console.log('true');
        return this.file.required;
      } else {
      console.log('false');
       return false
       }
    }
  }
}
</script>

<style lang="scss">
  @import '../../sass/_variables.scss';

  .dynamic-fileupload {
    height: $form-component-height;

    .custom-file-label {
      height: $form-component-height;
      border-radius: 3px;
      border: 1px solid $gray-300;
      background-color: $white;
      color: $gray-550;

      .form-file-text {
        line-height: 34px;
      }

      &::after {
        content: "Buscar" !important;
        height: 46px;
        line-height: 33px;
        border: 1px solid $accent;
        border-radius: 0 3px 3px 0;
        background-color: $white;

        &:hover {
          background-color: $accent;
          color: $white;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/DynamicForms/FileUpload.vue